const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

function parseDate(value: string): Date {
  if (!DATE_RE.test(value)) throw new Error(`Date civile invalide: ${value}`);
  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(Date.UTC(year!, month! - 1, day));
  if (date.toISOString().slice(0, 10) !== value) throw new Error(`Date civile invalide: ${value}`);
  return date;
}

export function isCivilDate(value: string): boolean {
  try {
    parseDate(value);
    return true;
  } catch {
    return false;
  }
}

export function isMonday(value: string): boolean {
  return isCivilDate(value) && mondayOf(value) === value;
}

export function addCalendarDays(value: string, amount: number): string {
  const date = parseDate(value);
  date.setUTCDate(date.getUTCDate() + amount);
  return date.toISOString().slice(0, 10);
}

export function mondayOf(value: string): string {
  const date = parseDate(value);
  const distance = (date.getUTCDay() + 6) % 7;
  return addCalendarDays(value, -distance);
}

export function weekDays(weekStart: string): string[] {
  return Array.from({ length: 7 }, (_, index) => addCalendarDays(weekStart, index));
}

/** Date civile dans le fuseau de la filiale, indépendante du fuseau du navigateur. */
export function civilTodayInZone(timeZone: string, now = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(now);
  const read = (type: Intl.DateTimeFormatPartTypes) => parts.find((part) => part.type === type)?.value;
  return `${read('year')}-${read('month')}-${read('day')}`;
}

export function formatCivilDate(value: string, locale: string, options: Intl.DateTimeFormatOptions = {}): string {
  return new Intl.DateTimeFormat(locale, { timeZone: 'UTC', ...options }).format(parseDate(value));
}

export function formatInZone(value: string | null, locale: string, timeZone: string): string {
  if (!value) return '—';
  return new Intl.DateTimeFormat(locale, { timeZone, hour: '2-digit', minute: '2-digit' }).format(new Date(value));
}
